import React from "react";
import { Button } from "@headlessui/react";
import {useNotification} from "../Notifications/NotificationProvider";

const COLOR_MAP = {
  green: {
    bg: "bg-green-600",
    text: "text-green-600",
    ring: "ring-green-600/30",
    icon: "text-green-600",
  },
  blue: {
    bg: "bg-blue-600",
    text: "text-blue-600",
    ring: "ring-blue-600/30",
    icon: "text-blue-600",
  },
  orange: {
    bg: "bg-orange-500",
    text: "text-orange-500",
    ring: "ring-orange-500/30",
    icon: "text-orange-500",
  },
  red: {
    bg: "bg-red-600",
    text: "text-red-600",
    ring: "ring-red-600/30",
    icon: "text-red-600",
  },
  gray: {
    bg: "bg-gray-600",
    text: "text-gray-600",
    ring: "ring-gray-600/30",
    icon: "text-gray-600",
  },
};

const ActionPillButton =({
  label,
  icon: Icon,
  onClick,
  color = "green",
  className = "",
  disabled,
}) => {
  const c = COLOR_MAP[color] || COLOR_MAP.green;

      const { triggerNotification } = useNotification();

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={`
        group
        inline-flex items-center gap-2
        rounded-lg
        px-3 py-1
        text-xs font-semibold
        bg-transparent
        ring-1 ring-inset ${c.ring}
        transition-all duration-500
        hover:${c.bg}
        ${disabled ? "opacity-40 cursor-not-allowed" : "hover:shadow-sm hover:-translate-y-[1px]"}
        ${className}
      `}
    >
      {Icon && (
        <Icon
          className={`
            size-4
            ${c.icon}
            group-hover:text-white
            transition-transform duration-300
            ${disabled ? "" : "group-hover:rotate-12"}
          `}
        />
      )}

      <span className={`${c.text} group-hover:text-white font-semibold tracking-tight transition-colors`}>
        {label}
      </span>
    </Button>
  );
}

export default ActionPillButton;
